define('lq/conditions/conditions',[
    'underscore',
    './conditionEvaluator'
], function (_, ConditionEvaluator) {
    'use strict';

    var Conditions = function (conditions, piping) {
        this.piping = piping;

        this.conditionsById = {};
        this.evaluatorsById = {};

        var self = this;
        _.each(conditions, function (condition) {
            self.conditionsById[condition.id] = condition;
        });
    };

    Conditions.supportedValues = ['View', 'Query', 'Value', 'Parameter', 'Boolean'];
    Conditions.supportedOperators = ['=', '≠', '>', '≥', '≤', '<', 'contains'];

    Conditions.prototype.getConditionEvaluator = function (idOfConditionOrConditionObject) {
        if (_.isString(idOfConditionOrConditionObject)) {
            if (this.evaluatorsById[idOfConditionOrConditionObject] === undefined) {
                if (this.conditionsById[idOfConditionOrConditionObject] === undefined) {
                    this.piping.errorHandler.showErrorDialog(new Error('Condition with id ' + idOfConditionOrConditionObject + ' does not exist.'));
                    return;
                }
                var condition = this.conditionsById[idOfConditionOrConditionObject];
                this.evaluatorsById[idOfConditionOrConditionObject] = new ConditionEvaluator(condition, this.piping);
            }

            return this.evaluatorsById[idOfConditionOrConditionObject];
        }

        return new ConditionEvaluator(idOfConditionOrConditionObject, this.piping);
    };

    return Conditions;
});
